import React from 'react';
import { connect } from 'react-redux';

import Main from '../Main';

class ConsumerPortal extends React.PureComponent {
  render() {
    const { translationSites } = this.props;

    return <Main site={translationSites.consumer} siteName="Consumer" />;
  }
}

const mapStateToProps = (store) => ({
  translationSites: store.translations.translationSites,
});

export default connect(mapStateToProps)(ConsumerPortal);
